export const locale = {
    Loading: {
        Waiting : "Please Wait",
        Description : "waiting to response",
    },
    Questions:{
        Yes : "Yes",
        No : "No"
    },
    Success:{
        Title : "Success",
        defaultActionText : "Ok"
    },
    Info:{
        Title : "Information",
        defaultActionText : "Ok"
    },
    Warning:{
        Title : "Attention",
        defaultActionText : "Ok"
    },
    Error:{
        Title : "Error",
        defaultActionText : "Ok"
    },
    Wallet:{
        Title : "No Balance",
        defaultActionText : "Ok"
    },
    ConnectionLost :{
        Title : "Connection Lost",
        Subtitle: "Please check connection",
        Button : "Try Again"
    }
}